import { feature as topoToGeo } from "topojson-client";

const convertTopoIfNeeded = topologyObjectsName => json => {
    return topologyObjectsName
        ? topoToGeo(json, json.objects[topologyObjectsName])
        : json;
};
const toJSON = response => response.json();
const fetchJson = url => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
    return dispatch => {
        dispatch({ type: "GEOJSON:REQUEST" });
        return fetchJson(url)
            .then(convertTopoIfNeeded(topologyObjectsName))
            .then(geojson =>
                dispatch({ type: "GEOJSON:SUCCESS", payload: geojson })
            )
            .catch(error =>
                dispatch({ type: "GEOJSON:FAILURE", payload: error })
            );
    };
};

const sheetId = "1-k6eSMD-6rqp9YnXiHd0Zo1T8AC4-C6wAXhqfBhluXs";
export const sheetIdToUrl = id =>
    `https://holy-sheet.visualise.today/sheet/${id}`;

export const getAllProjects = () => {
    return dispatch => {
        return fetchJson(
            sheetIdToUrl(`${sheetId}?range='${encodeURIComponent("Data")}'`)
        )
            .then(data => {
                dispatch({
                    type: "PROJECT:ALL:SUCCESS",
                    payload: data,
                });
            })
            .catch(err => {
                console.log(err);
                dispatch({ type: "PROJECT:ALL:ERROR", payload: err });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/data.js